// QueryClient factory for shared/query.
// See react-rewrite-plan.md sections 6.3 and 11.4 query-provider.

import { QueryClient, type DefaultOptions } from '@tanstack/react-query';
import { defaultQueryClientOptions } from './defaults';

export interface CreateQueryClientOptions {
  // Caller-supplied overrides are merged on top of the conservative
  // defaults. Use this for tests that want retry disabled, or for screens
  // that have a real reason to deviate.
  defaultOptions?: DefaultOptions;
}

export function createQueryClient(opts?: CreateQueryClientOptions): QueryClient {
  const defaults: DefaultOptions = {
    ...defaultQueryClientOptions,
    ...(opts?.defaultOptions ?? {}),
    queries: {
      ...defaultQueryClientOptions.queries,
      ...(opts?.defaultOptions?.queries ?? {}),
    },
    mutations: {
      ...defaultQueryClientOptions.mutations,
      ...(opts?.defaultOptions?.mutations ?? {}),
    },
  };
  return new QueryClient({ defaultOptions: defaults });
}
